<template>
  <div class="recommend-teacher-container" v-if="recommend&&recommend.length>0">
    <!-- 主轮播区域 -->
    <div class="main-carousel">
      <transition name="carousel-fade" mode="out-in">
        <div key="{{ currentTeacher.id }}" class="teacher-card">
          <div class="teacher-info" style="display: flex;flex-direction: column;justify-content: space-between;padding: 0 20px;height: 300px">
            <div>
            <div class="teacher-name">{{ currentTeacher.name }}</div>
            <div class="teacher-rating">
              <span class="icon-star"></span><span class="icon-star"></span><span class="icon-star"></span><span class="icon-star"></span><span class="icon-star"></span>
              <!-- <span class="score">{{ currentTeacher.rating }}</span> -->
              <!-- <span class="review-count">评分</span> -->
            </div>
            <div class="teacher-desc">{{ currentTeacher.description }}</div>
            

          </div>
                    <router-link
            @click.native.stop
            :to="{
              name: 'ShowTeachersDetaial',
              params: { id: currentTeacher.id },
              query: { route_name: 'ShowTeachers', route_label: '名师' },
            }"
          >
            <button class="detail-btn">了解详情</button>
          </router-link>

          </div>
          <div class="teacher-image">
            <img :src="currentTeacher.imageUrl" :alt="currentTeacher.name">
          </div>
        </div>
      </transition>

      <!-- 轮播控制按钮 -->
      <button class="carousel-control prev" @click="prevTeacher">
        <svg t="1755682507315" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5708" width="20" height="20"><path d="M276.755 942.936c28.497 29.315 74.739 29.315 103.307 0l367.236-378.011c28.483-29.367 28.483-76.982 0-106.291l-367.236-377.997c-28.562-29.367-74.806-29.367-103.307 0-28.546 29.325-28.546 76.929 0 106.304l315.6 324.841-315.599 324.803c-28.545 29.367-28.544 76.973 0 106.356l0 0z" fill="#ffffff" p-id="5709"></path></svg>
      </button>
      <button class="carousel-control next" @click="nextTeacher">
        <svg t="1755682507315" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5708" width="20" height="20"><path d="M276.755 942.936c28.497 29.315 74.739 29.315 103.307 0l367.236-378.011c28.483-29.367 28.483-76.982 0-106.291l-367.236-377.997c-28.562-29.367-74.806-29.367-103.307 0-28.546 29.325-28.546 76.929 0 106.304l315.6 324.841-315.599 324.803c-28.545 29.367-28.544 76.973 0 106.356l0 0z" fill="#ffffff" p-id="5709"></path></svg>
      </button>
    </div>

    <!-- 侧边教师列表 -->
    <div class="teacher-list">
      <div  @mouseenter="handleEnter" @mouseleave="handleLeave" class="teacher-items-container" ref="teacherItemsContainer">
        <div v-for="(teacher, index) in teachers" :key="teacher.id" 
             class="teacher-item" :class="{ active: index === currentIndex }"
             @click="switchTeacher(index)">
          <img :src="teacher.avatar" :alt="teacher.name">
          <div class="teacher-item-info">
            <div class="teacher-item-name">{{ teacher.name }}</div>
            <div class="teacher-item-title">{{ teacher.title }}</div>
          </div>
        </div>
      </div>

      <router-link
          @click.native.stop
          :to="{ name: 'ShowTeachers' }"
        >
        <button class="view-all-btn">查看全部</button>
      </router-link>
      
    </div>
  </div>
</template>

<script>
export default {
  props: {
    recommend: {
      type: Array,
    },
  },
  data() {
    return {
      currentIndex: 0,
      teachers: []
    }
  },
  computed: {
    currentTeacher() {
      return this.teachers[this.currentIndex];
    }
  },
  created() {
    // 确保有足够的讲师数据用于滚动展示
    console.log(666,this.recommend)
    this.teachers = this.recommend.map((item => {
      return {
        id: item.teacher_id,
        name: item.teacher_name,
        description: item.introduction,
        title: item.marketing_language,
        imageUrl: item.photo,
        avatar: item.teacher_avatar
      }
    }))
    
    console.log(445, this.teachers)
  },
  methods: {
    nextTeacher() {
      this.currentIndex = (this.currentIndex + 1) % this.teachers.length;
      // 确保切换后也能正确滚动
      this.scrollToActiveTeacher();
    },
    prevTeacher() {
      this.currentIndex = (this.currentIndex - 1 + this.teachers.length) % this.teachers.length;
      // 确保切换后也能正确滚动
      this.scrollToActiveTeacher();
    },
    switchTeacher(index) {
      this.currentIndex = index;
      this.scrollToActiveTeacher();
    },
    // 提取为单独的滚动方法，方便复用
    scrollToActiveTeacher() {
      this.$nextTick(() => {
        const container = this.$refs.teacherItemsContainer;
        if (!container || !container.children.length) return;
        
        // 使用更可靠的方式获取当前激活的讲师项
        const activeTeacherItem = container.querySelector(`.teacher-item.active`);
        const firstTeacherItem = container.children[0];
        
        if (this.currentIndex === 0 && firstTeacherItem) {
          // 如果是第一个讲师，强制滚动到顶部
          container.scrollTop = 0;
          console.log('滚动到顶部');
        } else if (activeTeacherItem) {
          // 对于其他讲师，计算并滚动到适当位置
          const containerRect = container.getBoundingClientRect();
          const itemRect = activeTeacherItem.getBoundingClientRect();
          
          // 计算滚动偏移量，确保选中项在视图中间
          const scrollOffset = itemRect.top - containerRect.top - (containerRect.height / 2) + (itemRect.height / 2);
          container.scrollTop += scrollOffset;
          console.log('滚动到选中项，偏移量:', scrollOffset);
        }
      });
    },
    handleEnter(){
      clearInterval(this.autoPlayInterval);
    },
    handleLeave(){
      this.autoPlay()
    },
    autoPlay(){
      // 自动轮播
      this.autoPlayInterval = setInterval(() => {
        this.nextTeacher();
      }, 5000);
    }
  },
  mounted() {

    this.autoPlay()
    // 初始化时确保第一个讲师可见
    this.$nextTick(() => {
      this.scrollToActiveTeacher();
    });
  },
  beforeDestroy() {
    // 清除自动轮播定时器
    if (this.autoPlayInterval) {
      clearInterval(this.autoPlayInterval);
    }
  }
};
</script>

<style scoped lang="scss">
.recommend-teacher-container {
  display: flex;
  width: 100%;
  max-width: 1180px;
  background-color: #f5f7fa;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  margin-bottom: 60px;
  background-image: url("~@/assets/images/home-teacher.jpg");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 100% 120%;
  padding: 10px !important;
}

.main-carousel {
  flex: 1;
  position: relative;

  /* background: linear-gradient(135deg, #bb1c20, #c02429); */

  color: white;
  overflow: hidden;
}

.teacher-card {
  display: flex;
  height: 100%;
  padding: 40px;
  box-sizing: border-box;
}

.teacher-info {
  flex: 1;
  padding-right: 20px;
}

  /* .items-t {
    padding-bottom: 0 !important;
  } */

.teacher-name {
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 15px;
}

.teacher-rating {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.icon-star {
  display: inline-block;
  width: 20px;
  height: 20px;
  background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="%23FFD700"><path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"/></svg>');
  margin-right: 5px;
}

.score {
  font-size: 20px;
  font-weight: bold;
  margin-right: 10px;
}

.review-count {
  font-size: 14px;
  opacity: 0.8;
}

.teacher-desc {
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 25px;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.detail-btn {
  background-color: #bb1c20;
  color: #fff;
  border: none;
  padding: 10px 20px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s;
  margin-top: 10px;
}

.detail-btn:hover {
  background-color: #bb1c20;
  transform: translateY(-2px);
}

.teacher-image {
  flex: 0 0 250px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.teacher-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

.carousel-control {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  background-color: rgba(255, 255, 255, 0.3);
  color: white;
  border: none;
  border-radius: 50%;
  font-size: 20px;
  cursor: pointer;
  transition: all 0.3s;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
}

.carousel-control.prev {
  left: 10px;
  transform: rotateY(180deg);
  margin-top: -20px;
}

.carousel-control.next {
  right: 10px;
}

.carousel-control:hover {
  background-color: rgba(255, 255, 255, 0.5);
}

.teacher-list {
  width: 280px;
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  height: 100%; /* 确保列表占满高度 */
}

.teacher-items-container {
  flex: 1;
  overflow-y: auto;
  /* margin-bottom: 15px; */
  /* 添加滚动条样式 */
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.3) transparent;
  /* 设置最大高度，确保最多显示4个讲师，其他需要滚动 */
  max-height: 366px;
  /* 添加过渡效果使滚动更平滑 */
  scroll-behavior: smooth;
}

.teacher-items-container::-webkit-scrollbar {
  width: 6px;
}

.teacher-items-container::-webkit-scrollbar-track {
  background: transparent;
}

.teacher-items-container::-webkit-scrollbar-thumb {
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 3px;
}

.teacher-item {
  display: flex;
  align-items: center;
  padding: 10px;
  margin-bottom: 15px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  background: #373853;
  border-width: 0.5px;
}

.teacher-item:hover,
.teacher-item.active {
  background-color: rgba(190, 189, 189, 0.1);
  /* transform: translateX(5px); */
  /* 新增放大效果 */
  /* transform: scale(1.05); */
  transform-origin: center;
  
  /* 保持原有圆角 */
  border-radius: 8px;
  img{
    background-color: #373853;
  }
  border: 0.5px solid rgba(255, 255, 255, 0.3);
}

.teacher-item img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 15px;
  background-color: #6b6b81;
}

.teacher-item-info {
  flex: 1;
}

.teacher-item-name {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 5px;
  color: #fff;
}

.teacher-item-title {
  font-size: 13px;
  color: #ffffff80;
}

.view-all-btn {
  width: 100%;
  padding: 12px;
  background-color: #535472;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s;
  margin-top: 15px;
}

.view-all-btn:hover {
  background-color: #bb1c20;
  transform: translateY(-2px);
}

.carousel-fade-enter-active,
.carousel-fade-leave-active {
  transition: opacity 0.5s;
}

.carousel-fade-enter,
.carousel-fade-leave-to {
  opacity: 0;
}

/* @media (max-width: 992px) {
  .recommend-teacher-container {
    flex-direction: column;
  }

  .main-carousel {
    height: 500px;
  }

  .teacher-card {
    flex-direction: column;
    text-align: center;
  }

  .teacher-info {
    padding-right: 0;
    margin-bottom: 20px;
  }

  .teacher-image {
    flex: 0 0 auto;
    width: 200px;
    margin: 0 auto;
  }

  .teacher-list {
    width: 100%;
    display: flex;
    overflow-x: auto;
    padding: 15px;
  }

  .teacher-item {
    flex: 0 0 200px;
    flex-direction: column;
    text-align: center;
    margin-right: 15px;
    margin-bottom: 0;
  }

  .teacher-item img {
    margin-right: 0;
    margin-bottom: 10px;
  }

  .view-all-btn {
    display: none;
  }
} */
</style>